var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9604_12636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.49805C3.6675 1.49805 3 2.16555 3 2.99805V14.998C3 15.3959 3.15804 15.7774 3.43934 16.0587C3.72064 16.34 4.10218 16.498 4.5 16.498H7.5V15.0655L9.0675 13.498H4.5V11.998H10.5675L12.0675 10.498H4.5V8.99805H13.5675L15 7.56555V5.99805L10.5 1.49805H4.5ZM9.75 2.62305L13.875 6.74805H9.75V2.62305ZM15.1125 9.74805C15.057 9.74683 15.0018 9.75683 14.9503 9.77745C14.8987 9.79807 14.8519 9.82889 14.8125 9.86805L14.0475 10.633L15.615 12.193L16.38 11.4355C16.5375 11.2705 16.5375 11.0005 16.38 10.843L15.405 9.86805C15.3668 9.82945 15.3212 9.79894 15.2709 9.77833C15.2207 9.75771 15.1668 9.74741 15.1125 9.74805ZM13.605 11.0755L9 15.688V17.248H10.56L15.1725 12.6355L13.605 11.0755Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9604_12636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractsIcon);
export default __webpack_public_path__ + "static/media/contractsIcon.82c1913676d1fe80289a1f134c0b2290.svg";
export { ForwardRef as ReactComponent };